import { Theme, css } from '@emotion/react';

export const container = ({ colors, spacing }: Theme) => css`
  background: ${colors.bgLighter};
  padding: ${spacing(2)}px;
`;

export const heading = ({ spacing }: Theme) => css`
  align-items: center;
  display: flex;
  gap: ${spacing(1)}px;
  margin-bottom: ${spacing(2)}px;
`;
